import { Injectable } from '@angular/core';

// RxJs
import { EMPTY, of, switchMap, tap } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

// NgRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  DepreciationFourthStepEffectsActions, DepreciationSecondStepEffectsActions,
  DepreciationThirdStepEffectsActions
} from '../actions/depreciation.actions';
import { WarrantyRecoveryEffectsActions } from '../actions/warranty.actions';
import { SessionEffectsActions } from '../actions/session.actions';

// Services
import { SecurityService } from '../../providers/services/security/security.service';



@Injectable()
export class SessionEffects {


  logOut$ = createEffect(() => this.actions$.pipe(
    ofType(SessionEffectsActions.logOut),
    mergeMap(() => this.securityService.logOut().pipe(
      map(() => SessionEffectsActions.ejectUser()),
      catchError(({ error }) => of(SessionEffectsActions.injectError({ error })))
    )))
  );


  logIn$ = createEffect(() => this.actions$.pipe(
    ofType(SessionEffectsActions.logIn),
    mergeMap(() => this.securityService.logIn().pipe(
      // map(() => SessionEffectsActions.injectUser()), // TO-DO: Move logic from service to here
      catchError(({ error }) => of(SessionEffectsActions.injectError({ error })))
    ))), { dispatch: false }
  );


  constructor(
    // private usersService: UsersService,
    private securityService: SecurityService,
    private readonly actions$: Actions,
  ) { }
}
